import getEditToken from "../../getters/editToken";

const mermaidToken = getEditToken("mermaid");
export default mermaidToken;
